const defaultEvents = [
  {
    selector: '.header__phones .contact-group__item',
    hasMultipleElements: true,
    eventName: 'click_phone',
    hasLocalByDOM: true,
    normalizer: 'normalizeContactLocal',
  },
  {
    selector: '.header__whatsapps .contact-group__item',
    hasMultipleElements: true,
    eventName: 'click_whatsapp',
    hasLocalByDOM: true,
    normalizer: 'normalizeContactLocal',
  },
  {
    selector: '.showcase__banner-image',
    hasMultipleElements: true,
    eventName: 'click_banner',
    hasLocalByDOM: true,
    normalizer: 'normalizeBannerName',
  },
  {
    selector: '.channel-pop-up__image',
    hasMultipleElements: false,
    eventName: 'click_popup_home',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.floating-whatsapp .contact-group__item',
    hasMultipleElements: true,
    eventName: 'flutuante',
    hasLocalByDOM: true,
    normalizer: 'normalizeContactLocal',
  },
];

const indexEvents = [
  {
    selector: '.new-vehicles-whatsapp__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_carrossel_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.new-vehicles-fiatv2-lazy .button--financing-simulator',
    hasMultipleElements: false,
    eventName: 'click_simulador_financiamento_carrossel_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.page--home .financing-simulator-section .button',
    hasMultipleElements: false,
    eventName: 'click_simulador_financiamento_banner_index',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const newVehicleShowEvents = [
  {
    selector: '.showcase-new-cars__whatsapp-button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const offerShowEvents = [
  {
    selector: '.offers-showcase__whatsapp-box__cta .button--whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const usedModelShowEvents = [
  {
    selector: '.used-vehicles-showcase__whatsapp-box__cta .button--whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_seminovos',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

export {
  defaultEvents,
  indexEvents,
  newVehicleShowEvents,
  offerShowEvents,
  usedModelShowEvents,
};
